import { useEffect, useState } from 'react';
import '../../scss/backoffice.scss';
import { Sidemenu } from './Sidemenu';
import { Topbar } from './Topbar';
import { Footer } from './Footers';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Badge } from '../../components/backend/Badge';
import { SchedulerLists } from '../../model/datatype';
import {
  GetSchedulers,
  UpdateSchedules,
} from '../../services/APiGetSchedulers';
import moment from 'moment-timezone';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Alert } from 'react-bootstrap';

export const Schedulers = (props: any) => {
  const [templateError, setTemplateError] = useState('');
  const [loder, setLoader] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [formInput, setFormInput] = useState({
    id: 0,
    startDate: '',
    endDate: '',
  });
  const [scheduleLists, setScheduleLists] = useState<[SchedulerLists] | null>(
    null,
  );
  const current_year = new Date().getFullYear() + 1;
  const years = [];
  const timezoneStr = Intl.DateTimeFormat().resolvedOptions().timeZone || 'FallbackTimeZone';

  for (let startY = current_year; startY > current_year - 4; startY--) {
    years.push(startY);
  }

  const handleSwitch = () => {
    setChecked(!checked);
    if (!checked) {
      setFormInput((oldValues: any) => ({ ...oldValues, ['status']: true }));
    } else {
      setFormInput((oldValues: any) => ({ ...oldValues, ['status']: false }));
    }
  };
  const setInputValue = (e: any) => {
    const { name, value } = e.target;
    setFormInput((oldValues: any) => ({ ...oldValues, [name]: value }));
  };
  const convertMonth = (month: number) => {
    return [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ][month - 1];
    // console.log(month);
    // const date = new Date();
    // date.setMonth(month - 1);
    // return date.toLocaleString('en-US', { month: 'long'});
  };
  const hendelEdit = (item: any) => {
    setFormInput({
      id: item.id,
      startDate: convertDateServerToTimeZome(item.startDate),
      endDate: convertDateServerToTimeZome(item.endDate),
    });
    setModalShow(true);
  };

  const onSelectedYear = (year: any) => {
    setLoader(false);
    setScheduleLists(null);
    setSelectedYear(year);
  };
  const onSubmit = () => {
    console.log(formInput);
    UpdateSchedules(formInput)
      .then((response: any) => {
        const getData: any = response;
        console.log('getData=', getData);
        setModalShow(false);
        getSchedulers();
        toast.success('Salary scheduler updated successfully.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFormInput({
          id: 0,
          startDate: '',
          endDate: '',
        });
      })
      .catch((error: any) => {
        console.log(error);
        setTemplateError(error.toString());
      });
    setTemplateError('');
  };
  const getSchedulers = () => {
    setLoader(true);
    GetSchedulers(selectedYear).then((response: any) => {
      const getData: any = response;
      setScheduleLists(getData);
      setLoader(false);
    });
  };

  const convertDateServerToTimeZome = (date: string) => {
    if (date !== '') {
      console.log(`date=${date}, timezone=${timezoneStr}`);
      console.log(
        moment(date + 'Z')
          .tz(timezoneStr)
          .format('yyyy-MM-DDTHH:mm'),
      );
      return moment(date + 'Z')
        .tz(timezoneStr)
        .format('yyyy-MM-DDTHH:mm');
    } else {
      return '';
    }
  };

  let helpModalClose = () => {
    setModalShow(false);
    setTemplateError('');
  };
  useEffect(() => {
    console.log('formInputUseEffect=', formInput);
    setLoader(true);
    getSchedulers();
  }, [selectedYear, formInput]);

  console.log('scheduleLists=', scheduleLists);

  for (let i = 1; i <= 12; i++) {
    console.log(convertMonth(i));
  }
  return (
    <>
      <div className="container-fiuld master-layout">
        <Sidemenu />
        <div className="main-container">
          <div className="col-12 mb-4">
            <Topbar />
          </div>
          <div className="container-fuild">
            <div className="row mb-2">
              <div className="col-12 my-3">
                <h1 className="page-title">Adv. Salary Request Schedulers</h1>
              </div>
              <div className="col-12 col-sm-12 col-md-12">
                <div className="block-shadow px-2">
                  <div className="w-100 my-3">
                    <div className="select-block  ms-auto w-auto">
                      <div className="d-flex hr-select">
                        <div className="ddl-icon">
                          <img
                            className="a-edit"
                            src="../../../images/backoffice/calendar-orange.png"
                          />
                        </div>
                        <div className="ddl-text">{selectedYear}</div>
                        <div className="ddl-arrow">
                          <img
                            className="a-edit"
                            src="../../../images/backoffice/chevron-down.png"
                          />
                        </div>
                      </div>
                      <ul className="ul-list">
                        {years.map((year: any) => (
                          <li
                            key={`y${year}`}
                            onClick={() => onSelectedYear(year)}
                          >
                            {year}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <table className="table hr-table">
                    <thead>
                      <tr>
                        <th scope="col">YEAR</th>
                        <th scope="col">MONTH</th>
                        <th scope="col">START DATE</th>
                        <th scope="col">END DATE</th>
                        <th scope="col">LAST UPDATE</th>
                        <th scope="col" className="text-center">
                          STATUS
                        </th>
                        <th scope="col" className="text-center">
                          EDIT
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {scheduleLists ? (
                        scheduleLists.map((item: any, key: number) => (
                          <tr key={`tr-${key}`}>
                            <td>{item.year}</td>
                            <td>{convertMonth(item.month)}</td>
                            <td>
                              {moment(item.startDate + 'Z')
                                .tz(timezoneStr)
                                .format('DD-MM-YYYY HH:mm:ss')}
                            </td>
                            <td>
                              {moment(item.endDate + 'Z')
                                .tz(timezoneStr)
                                .format('DD-MM-YYYY HH:mm:ss')}
                            </td>
                            <td>
                              {item.modifiedDateTime !== null
                                ? moment(item.modifiedDateTime + 'Z')
                                    .tz(timezoneStr)
                                    .format('DD-MM-YYYY HH:mm:ss')
                                : ''}
                            </td>
                            <td className="text-center">
                              <Badge
                                status={item.statusStr}
                                text={item.statusStr}
                              />
                            </td>
                            <td className="text-center">
                              <img
                                className="a-edit"
                                src="../../../images/backoffice/edit.png"
                                onClick={() => hendelEdit(item)}
                              />
                              {/* {(item.statusStr !== "InActive") ?
                                                                    <img className="a-edit" src="../../../images/backoffice/edit.png" onClick={() => hendelEdit(item)} />
                                                                    :
                                                                    <img className="a-edit opacity-25" src="../../../images/backoffice/edit.png" />
                                                                } */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={7} className="tr_loding">
                            {loder ? (
                              <div className="loader-box">
                                <div className="spinner"></div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
        onHide={helpModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title className="contained-modal-title-vcenter justify-content-center hr-modal-title">
            Edit adv. Salary Schedulers
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5">
          {templateError !== '' ? (
            <Alert key="danger" variant="danger" className="message p-2">
              {templateError}
            </Alert>
          ) : (
            <></>
          )}
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 mb-4">
              <div className="form-group">
                <label className="mb-2">Start Date</label>
                <input
                  type="datetime-local"
                  value={formInput?.startDate}
                  className="form-control"
                  id="start_date"
                  aria-describedby="Start Date"
                  placeholder=""
                  name="startDate"
                  onChange={setInputValue}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 mb-4">
              <div className="form-group">
                <label className="mb-2">End Date</label>
                <input
                  type="datetime-local"
                  value={formInput?.endDate}
                  className="form-control"
                  id="end_date"
                  aria-describedby="End Date"
                  placeholder=""
                  name="endDate"
                  onChange={setInputValue}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onSubmit()} className="btn-submit">
            Submit
          </Button>
          <Button onClick={() => helpModalClose()} className="btn-cancel">
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </>
  );
};
